import bridge from 'libs/bridge';
import openLink, { nativeReplace } from 'libs/open-link';
import * as link from '@byted/ecom-mobile-lib/lib/core/link';
import env from 'libs/env';
export default function (url: string, config?: any) {
    // 目前火山端指定关闭url有问题
    const openGap =
        ({
            douyin: 300
        } as any)[env.appName] || 0;

    const specialEnv = ['xigua', 'huoshan', 'super', 'automobile', 'toutiaolite'];
    const openConfig = { ...config, closeAndOpen: env.isInVideo };
    if (bridge.supports('close')) {
        openLink(url, openConfig);
        document.addEventListener('visibilitychange', () => {
            // 页面变为不可见，视作成功呼起支付应用，取消呼起失败的timeout
            if (document.visibilityState === 'visible') {
                close();
            }
        });
        if (!specialEnv.includes(env.appName)) {
            setTimeout(() => {
                close();
            }, openGap);
        }
    } else {
        nativeReplace(url);
    }
}

export const close = () => {
    bridge.call('close', {
        reactId: (window as any).reactId,
        url: window.location.href
    });
};
